import React from 'react';
import styled from 'styled-components';
import {
  space,
  SpaceProps,
  width,
  WidthProps,
  maxWidth,
  MaxWidthProps,
  flex,
  height,
  FlexProps,
  themeGet
} from 'styled-system';

import { getLayoutProps } from 'src/helpers';
import { Text } from 'src/kit';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> &
  StyledLabelProps & {
    htmlFor?: string;
    label?: string;
    children?: React.ReactNode;
  };

export const Label = React.forwardRef(({ label, children, ...props }: LabelProps, ref: React.RefObject<any> | null) => {
  const [layoutProps, restStyledProps, restProps] = getLayoutProps(props);

  return (
    <StyledLabel as={label ? 'label' : 'div'} ref={ref} {...layoutProps} {...restProps}>
      {label && (
        <Text mb={10} fontSize={12} {...restStyledProps}>
          {label}
        </Text>
      )}
      {children}
    </StyledLabel>
  );
});

type StyledLabelProps = SpaceProps & WidthProps & MaxWidthProps & FlexProps & { disabled?: boolean };

const colors = {
  initial: themeGet('colors.textSecondary'),
  disabled: themeGet('colors.cloudyBlueTwo')
};

const StyledLabel = styled.label<StyledLabelProps>`
  margin: 0;
  display: block;
  color: ${props => (props.disabled ? colors.disabled : colors.initial)};
  font-weight: normal;
  ${space};
  ${width};
  ${maxWidth};
  ${height};
  ${flex};
`;
